var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-toolbar',[_c('img',{attrs:{"src":_vm.COMPANY_LOGO,"height":"40px"}})]),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('v-footer',{staticClass:"justify-center"},[_vm._v("\n    © "+_vm._s(_vm.COMPANY_NAME)+" "+_vm._s(_vm.getCurrentYear())+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fe2df64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 